import { useState, useEffect, useMemo } from "react";
import { useLocation, Outlet } from "react-router-dom";
import { Layout, Drawer, Grid, ConfigProvider } from "antd";
import { Helmet } from "react-helmet";
import MyMenu from "./SidenavMenus";
import Header from "./Header";
import Footer from "./Footer";
import logo2 from "../../../img/brand/brand.png";
import ValuesStore from "../../store/values-store";
import Utilities from "../../dependencies/custom/react-utilities";

const { Header: AntHeader, Content, Sider } = Layout;
const { useBreakpoint } = Grid;
const DEFAULT_BROWSER_TITLE = "Hillside Schools – Naalya";

function normalizePath(path = "") {
  const normalizedPath = `${path}`.replace(/\/+$/, "");
  return normalizedPath || "/";
}

function humanizeSegment(segment = "") {
  return segment
    .split(/[-_]/)
    .filter(Boolean)
    .map((word) => Utilities.capitalizeFirstLetter(word))
    .join(" ");
}

function resolveBrowserTitle(pathname, pages = []) {
  const normalizedPath = normalizePath(pathname);

  if (normalizedPath === "/" || normalizedPath === "/welcome/me") {
    return DEFAULT_BROWSER_TITLE;
  }

  if (normalizedPath === "/admin/accommodation") {
    return "Houses and Dormitories | Admin";
  }

  const matchedPage = pages.find(
    (page) => normalizePath(page?.route) === normalizedPath,
  );

  if (matchedPage) {
    const customName = matchedPage?.custom_name || matchedPage?.customName;
    const parentName = matchedPage?.parent;

    if (customName && parentName && parentName !== "null") {
      return `${customName} | ${parentName}`;
    }

    if (customName) {
      return customName;
    }
  }

  const segments = normalizedPath.split("/").filter(Boolean);
  if (!segments.length) {
    return DEFAULT_BROWSER_TITLE;
  }

  if (segments[0] === "admin" && segments.length >= 3) {
    return `${humanizeSegment(segments[segments.length - 1])} | ${humanizeSegment(segments[1])}`;
  }

  return humanizeSegment(segments[segments.length - 1]);
}

function Main() {
  const valuesStore = ValuesStore();
  const [myTheme] = useState("dark"); // "dark" or "light"
  const screens = useBreakpoint();
  const [visible, setVisible] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [placement, setPlacement] = useState("left");
  const sidebarWdith = 240;
  const sidebarCollapsedWidth = 100;
  const logoSmWidth = 50;

  const { pathname: currentPathname } = useLocation();
  let pathname = currentPathname.replace("/", "");
  let storedPages = [];
  try {
    const pagesFromStorage = JSON.parse(
      sessionStorage.getItem("pages") || "[]",
    );
    storedPages = Array.isArray(pagesFromStorage) ? pagesFromStorage : [];
  } catch (error) {
    storedPages = [];
  }
  const pages =
    Array.isArray(valuesStore.pages) && valuesStore.pages.length
      ? valuesStore.pages
      : storedPages;
  const browserTitle = useMemo(
    () => resolveBrowserTitle(currentPathname, pages),
    [currentPathname, pages],
  );

  useEffect(() => {
    setPlacement(pathname === "rtl" ? "right" : "left");
  }, [pathname]);

  /** MOBILE: open menu */
  const openDrawer = () => setVisible(true);

  return (
    <ConfigProvider
      theme={{
        algorithm: [],
        // token: {
        //   colorBgContainer: theme === "dark" ? "#001529" : "#fff",
        //   colorPrimary: "#1890ff",
        // },
        // algorithm:
        //   theme === "dark"
        //     ? ConfigProvider.theme.darkAlgorithm
        //     : ConfigProvider.theme.defaultAlgorithm,
      }}
    >
      <Helmet>
        <title>{browserTitle}</title>
      </Helmet>
      <Layout className="layout-dashboard">
        {/* ---------------------------------------------------------------------- */}
        {/*  MOBILE DRAWER SIDEBAR  */}
        {/* ---------------------------------------------------------------------- */}
        {!screens.md && (
          <Drawer
            placement={placement}
            open={visible}
            onClose={() => setVisible(false)}
            width={sidebarWdith}
            className="drawer-sidebar"
            style={{ background: "#001529" }}
          >
            <div style={{ padding: "20px 10px", textAlign: "center" }}>
              <img src={logo2} alt="logo" width={sidebarCollapsedWidth} />
              <div className="mt-2 fw-bold text-white" style={{ fontSize: 14 }}>
                Hillside Schools – Naalya
              </div>
            </div>
            <MyMenu
              myTheme={myTheme}
              // openKeys={menuState.openKeys}
              // selectedKeys={menuState.selectedKeys}
              // onStateChange={handleMenuState}
            />
          </Drawer>
        )}

        {/* ---------------------------------------------------------------------- */}
        {/*  DESKTOP SIDEBAR  */}
        {/* ---------------------------------------------------------------------- */}
        {screens.md && (
          <Sider
            collapsible
            collapsed={collapsed}
            onCollapse={(v) => setCollapsed(v)}
            width={sidebarWdith}
            theme={myTheme}
            style={{
              position: "fixed",
              height: "100vh",
              left: 0,
              top: 0,
            }}
          >
            <div style={{ padding: "20px 10px", textAlign: "center" }}>
              <img
                src={logo2}
                alt="logo"
                width={collapsed ? logoSmWidth : sidebarCollapsedWidth}
              />
              {!collapsed && (
                <div
                  className="mt-2 fw-bold text-white"
                  style={{ fontSize: 14 }}
                >
                  Hillside Schools – Naalya
                </div>
              )}
            </div>

            <MyMenu
              myTheme={myTheme}
              // collapsed={collapsed}
              // openKeys={menuState.openKeys}
              // selectedKeys={menuState.selectedKeys}
              // onStateChange={handleMenuState}
            />
          </Sider>
        )}

        {/* ---------------------------------------------------------------------- */}
        {/*  MAIN CONTENT AREA  */}
        {/* ---------------------------------------------------------------------- */}
        <Layout
          style={{
            marginLeft: screens.md
              ? collapsed
                ? sidebarCollapsedWidth
                : sidebarWdith
              : 0,
            transition: "all 0.3s",
            width: "100%",
          }}
        >
          <AntHeader>
            <Header onPress={openDrawer} name={pathname} subName={pathname} />
          </AntHeader>

          <div className="p-0 p-md-3">
            <Content className="content-ant">
              <Outlet />
            </Content>
          </div>

          <Footer />
        </Layout>
      </Layout>
    </ConfigProvider>
  );
}

export default Main;

// <Layout
//   className={`layout-dashboard ${pathname === "profile" ? "layout-profile" : ""
//     } ${pathname === "rtl" ? "layout-dashboard-rtl" : ""}`}
// >
//   <div className="d-flex">
//     <Drawer
//       title={false}
//       placement={placement === "right" ? "left" : "right"}
//       closable={false}
//       onClose={() => setVisible(false)}
//       open={visible}
//       key={placement === "right" ? "left" : "right"}
//       width={250}
//       className={`drawer-sidebar ${pathname === "rtl" ? "drawer-sidebar-rtl" : ""
//         } `}
//     >
//        <div style={{ padding: "20px 10px", textAlign: "center" }}>
//         <img src={logo2} alt="logo" width={collapsed ? 40 : 80} />
//         {!collapsed && (
//           <div
//             className="mt-2 fw-bold text-white"
//             style={{ fontSize: 14, lineHeight: "16px" }}
//           >
//             Hillside Schools Naalya
//           </div>
//         )}
//       </div>
//       <MyMenu color={sidenavColor} />
//     </Drawer>

//     <Sider
//       className={siderCssClasses}
//       collapsible
//       collapsed={collapsed}
//       onCollapse={() => setCollapsed(!collapsed)}
//       width={240}
//       theme="dark"
//       style={{
//         position: "fixed",
//         height: "100vh",
//         left: 0,
//         top: 0,
//       }}
//     >

//       <div style={{ padding: "20px 10px", textAlign: "center" }}>
//         <img src={logo2} alt="logo" width={collapsed ? 40 : 80} />
//         {!collapsed && (
//           <div
//             className="mt-2 fw-bold text-white"
//             style={{ fontSize: 14, lineHeight: "16px" }}
//           >
//             Hillside Schools Naalya
//           </div>
//         )}
//       </div>
//       <MyMenu color={sidenavColor} cssClasses={siderCssClasses} />
//     </Sider>

//     <Layout className="border" style={{
//       marginLeft: collapsed ? 80 : 240, // Dynamically adjust
//       transition: "all 0.3s"
//     }}>

//       {fixed ? (
//         <Affix>
//           <AntHeader className={`${fixed ? "ant-header-fixed" : ""}`}>
//             <Header
//               onPress={openDrawer}
//               name={pathname}
//               subName={pathname}
//               handleSidenavColor={handleSidenavColor}
//               handleSidenavType={handleSidenavType}
//               handleFixedNavbar={handleFixedNavbar}
//             />
//           </AntHeader>
//         </Affix>
//       ) : (
//         <AntHeader className={`${fixed ? "ant-header-fixed" : ""}`}>
//           <Header
//             onPress={openDrawer}
//             name={pathname}
//             subName={pathname}
//             handleSidenavColor={handleSidenavColor}
//             handleSidenavType={handleSidenavType}
//             handleFixedNavbar={handleFixedNavbar}
//           />
//         </AntHeader>
//       )}
//       <div className="p-0 p-md-3">
//         <Content className="content-ant"><Outlet /></Content>
//       </div>
//       <Footer />
//     </Layout>
//   </div>
// </Layout>
//   );
// }

// export default Main;
